import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		margin: '0 auto',
		transform: 'scale(1.5)',
		position: 'fixed',
		top: '25%',
		left: '50%',
		'& > * + *': {
			marginLeft: theme.spacing(2),
		},
	},
}));

const Spinner = () => {
	const classes = useStyles();
	const [progress, setProgress] = React.useState(0);

	React.useEffect(() => {
		function tick() {
			// reset when reaching 100%
			setProgress((oldProgress) => (oldProgress >= 100 ? 0 : oldProgress + 1));
		}

		const timer = setInterval(tick, 20);
		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<div className={classes.root}>
			<CircularProgress
				variant="determinate"
				value={progress}
				color="secondary"
			/>
		</div>
	);
};

export default Spinner;
